import { Component, Input, OnInit } from '@angular/core';
import { TournamentService } from 'src/app/modules/tournament/tournament.service';
import TabBase from '../tab-base';
@Component({
    selector: 'app-tab-classification',
    templateUrl: './classification.component.html',
    styleUrls: ['./classification.component.scss'],
})
export class TabClassificationComponent extends TabBase implements OnInit {
    /**
     * Parametros para listagem da classificação
     * @property { string } tournamentId - id do torneio
     * @property { categoryId } categoryId; - id da categoria
     */
    @Input() tournamentId: string;
    @Input() categoryId: string;

    /**
     * @description
     * @type {*}
     * @memberof TabClassificationComponent
     */
    public classification: any;

    /**
     * mensagem de retorno da api
     * @property {string} message
     */
    message;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.getClassification();
    }

    /**
     * @description
     * @param {string} header
     * @return {string}
     * @memberof TabClassificationComponent
     */
    getSplitedHeader(header) {
        return header.slice(2, header.length);
    }

    /**
     * Chama requisição para classificação do torneio
     * @private
     */
    private getClassification() {
        this.tournamentService.getClassification(this.tournamentId, this.categoryId).subscribe((response) => {
            this.classification = response.registers;
            this.message = response.description;
        });
    }
}
